import { Box, Center, Group } from "@mantine/core";
import { StaticImage } from "gatsby-plugin-image";
import React from "react";

import * as classes from "./LogoMarquee.module.css";

const logos = [
  <StaticImage
    src="../../images/clients/logo-act-cil.png"
    alt="ACT Center for Impact and Learning"
    placeholder="none"
    layout="constrained"
    objectFit="contain"
    objectPosition="center"
    style={{ height: "100%" }}
  />,
  <StaticImage
    src="../../images/clients/logo-fbcss.png"
    alt="First Baptist Sunny Side"
    placeholder="none"
    layout="constrained"
    objectFit="contain"
    objectPosition="center"
    style={{ height: "100%" }}
  />,
  <StaticImage
    src="../../images/clients/logo-asbn-coworks.png"
    alt="ASBN Coworks"
    placeholder="none"
    layout="constrained"
    objectFit="contain"
    objectPosition="center"
    style={{ width: 120, height: "100%" }}
  />,
  <StaticImage
    src="../../images/clients/logo-gic.png"
    alt="Georgia Institute of Cosmetology"
    placeholder="none"
    layout="constrained"
    objectFit="contain"
    objectPosition="center"
    style={{ height: "100%" }}
  />,
  <StaticImage
    src="../../images/clients/logo-autotrader-rvs.svg"
    alt="ACT Center for Impact and Learning"
    placeholder="none"
    layout="constrained"
    objectFit="contain"
    objectPosition="center"
    style={{ height: "100%", width: "100%" }}
  />,
  <StaticImage
    src="../../images/clients/logo-ronnie-thames-foundation.png"
    alt="Ronnie Thames Foundation"
    placeholder="none"
    layout="constrained"
    objectFit="contain"
    objectPosition="center"
    style={{ height: "100%" }}
  />,
  <StaticImage
    src="../../images/clients/logo-cricket-adlab.svg"
    alt="Cricket AdLab"
    placeholder="none"
    layout="constrained"
    objectFit="contain"
    objectPosition="center"
    style={{ width: 100, height: "100%" }}
  />,
  <StaticImage
    src="../../images/clients/logo-smith-currie.png"
    alt="Smith Currie OLES"
    placeholder="none"
    layout="constrained"
    objectFit="contain"
    objectPosition="center"
    style={{ width: 120, height: "100%" }}
  />,
  <StaticImage
    src="../../images/clients/logo-central-dispatch.svg"
    alt="Central Dispatch by Cox Automotive"
    placeholder="none"
    layout="constrained"
    objectFit="contain"
    objectPosition="center"
    style={{ width: 120, height: "100%" }}
  />,
  <StaticImage
    src="../../images/clients/logo-gordos.png"
    alt="Gordo's"
    placeholder="none"
    layout="constrained"
    objectFit="contain"
    objectPosition="center"
    style={{ width: 120, height: "100%" }}
  />,
  <StaticImage
    src="../../images/clients/logo-valentino.png"
    alt="Valentino & Associates"
    placeholder="none"
    layout="constrained"
    objectFit="contain"
    objectPosition="center"
    style={{ width: 80, height: "100%" }}
  />,
];

const logos2 = [
  <StaticImage
    src="../../images/clients/logo-navicent.png"
    alt="Navicent Health"
    placeholder="none"
    layout="constrained"
    objectFit="contain"
    objectPosition="center"
    style={{ width: 120, height: "100%" }}
  />,
  <StaticImage
    src="../../images/clients/logo-frank-betz.svg"
    alt="Frank Betz"
    placeholder="none"
    layout="constrained"
    objectFit="contain"
    objectPosition="center"
    style={{ width: 120, height: "100%" }}
  />,
  <StaticImage
    src="../../images/clients/logo-act-wrc.png"
    alt="ACT Work Ready Communities"
    placeholder="none"
    layout="constrained"
    objectFit="contain"
    objectPosition="center"
    style={{ height: "100%" }}
  />,
  <StaticImage
    src="../../images/clients/logo-atrium-health.png"
    alt="Atrium Health"
    placeholder="none"
    layout="constrained"
    objectFit="contain"
    objectPosition="center"
    style={{ width: 120, height: "100%" }}
  />,
  <StaticImage
    src="../../images/clients/logo-autotrader-motorcycles.svg"
    alt="AutoTrader Motorcycles"
    placeholder="none"
    layout="constrained"
    objectFit="contain"
    objectPosition="center"
    style={{ height: "100%", width: "100%" }}
  />,
  <StaticImage
    src="../../images/clients/logo-act.png"
    alt="ACT"
    placeholder="none"
    layout="constrained"
    objectFit="contain"
    objectPosition="center"
    style={{ width: 80, height: "100%" }}
  />,
  <StaticImage
    src="../../images/clients/logo-chino-salsa.svg"
    alt="Chino Salsa"
    placeholder="none"
    layout="constrained"
    objectFit="contain"
    objectPosition="center"
    style={{ width: 120, height: "100%" }}
  />,
  <StaticImage
    src="../../images/clients/logo-enforcer.png"
    alt="Enforcer"
    placeholder="none"
    layout="constrained"
    objectFit="contain"
    objectPosition="center"
    style={{ width: 140, height: "100%" }}
  />,
  <StaticImage
    src="../../images/clients/logo-manheim.png"
    alt="Manheim"
    placeholder="none"
    layout="constrained"
    objectFit="contain"
    objectPosition="center"
    style={{ width: 120, height: "100%" }}
  />,
  <StaticImage
    src="../../images/clients/logo-new-bridge-group.jpg"
    alt="New Bridge Group"
    placeholder="none"
    layout="constrained"
    objectFit="contain"
    objectPosition="center"
    style={{ width: 140, height: "100%" }}
  />,
  <StaticImage
    src="../../images/clients/logo-autotrader-classics.svg"
    alt="AutoTrader Classics"
    placeholder="none"
    layout="constrained"
    objectFit="contain"
    objectPosition="center"
    style={{ height: "100%", width: "100%" }}
  />,
];

export function LogoMarquee() {
  return (
    <Box className={classes.marqueeWrapper}>
      <Box className={classes.marqueeContainer}>
        <Box className={classes.gradientLeft} />
        <Box className={classes.gradientRight} />

        <Box className={classes.marqueeRow}>
          <Box className={classes.marqueeContent}>
            {[...Array(4)].map((_, groupIndex) => (
              <React.Fragment key={`row1-group-${groupIndex}`}>
                <Group
                  key={`row1-mobile-${groupIndex}`}
                  className={classes.marqueeTrack}
                  gap="md"
                  wrap="nowrap"
                  hiddenFrom="md"
                  style={{
                    filter: "grayscale(1)",
                    opacity: 0.5,
                  }}
                >
                  {logos.map((logo, index) => (
                    <Center
                      key={`row1-mobile-logo-${groupIndex}-${index}`}
                      className={classes.logoItem}
                      h={80}
                      w={160}
                    >
                      {logo}
                    </Center>
                  ))}
                </Group>

                <Group
                  key={`row1-desktop-${groupIndex}`}
                  className={classes.marqueeTrack}
                  gap="xl"
                  wrap="nowrap"
                  visibleFrom="md"
                  style={{
                    filter: "grayscale(1)",
                    opacity: 0.5,
                  }}
                >
                  {logos.map((logo, index) => (
                    <Center
                      key={`row1-desktop-logo-${groupIndex}-${index}`}
                      className={classes.logoItem}
                      h={80}
                      w={160}
                    >
                      {logo}
                    </Center>
                  ))}
                </Group>
              </React.Fragment>
            ))}
          </Box>
        </Box>

        <Box className={classes.marqueeRow}>
          <Box
            className={`${classes.marqueeContent} ${classes.marqueeContentOffset}`}
          >
            {[...Array(4)].map((_, groupIndex) => (
              <React.Fragment key={`row2-group-${groupIndex}`}>
                <Group
                  key={`row2-mobile-${groupIndex}`}
                  className={classes.marqueeTrack}
                  gap="md"
                  wrap="nowrap"
                  hiddenFrom="md"
                  style={{
                    filter: "grayscale(1)",
                    opacity: 0.5,
                  }}
                >
                  {logos2.map((logo, index) => (
                    <Center
                      key={`row2-mobile-logo-${groupIndex}-${index}`}
                      className={classes.logoItem}
                      h={80}
                      w={160}
                    >
                      {logo}
                    </Center>
                  ))}
                </Group>

                <Group
                  key={`row2-desktop-${groupIndex}`}
                  className={classes.marqueeTrack}
                  gap="xl"
                  wrap="nowrap"
                  visibleFrom="md"
                  style={{
                    filter: "grayscale(1)",
                    opacity: 0.5,
                  }}
                >
                  {logos2.map((logo, index) => (
                    <Center
                      key={`row2-desktop-logo-${groupIndex}-${index}`}
                      className={classes.logoItem}
                      h={80}
                      w={160}
                    >
                      {logo}
                    </Center>
                  ))}
                </Group>
              </React.Fragment>
            ))}
          </Box>
        </Box>
      </Box>
    </Box>
  );
}
